import AppLogout from "../pages/auth/AppLogout";
;

const withAuth = (Component) => {
  return (props) => (
    <AppLogout>
      <Component {...props} />
    </AppLogout>
  );
};

export default withAuth;
